import React from 'react';
import styles from './TextArea.module.css';
import VisuallyHidden from '../../shared/visuallyHidden/VisuallyHidden';
import { Label } from '../label/Label';
import classNames from 'classnames';
import { IconButton } from '../../buttons/icon/IconButton';
import { useTranslation } from 'react-i18next';

export interface ITextArea {
  label: string;
  labelHidden?: boolean;
  password?: boolean;
  hasError?: boolean;
  rows?: number;
  cols?: number;
  value?: string;
  disabled?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  name?: string;
  onBlur?: (event: React.FocusEvent<HTMLTextAreaElement>) => void;
  onFocus?: (event: React.FocusEvent<HTMLTextAreaElement>) => void;
  onPaste?: (event: React.ClipboardEvent<HTMLTextAreaElement>) => string;
}

const TextArea = ({
  label,
  labelHidden,
  hasError,
  name,
  value,
  rows = 5,
  cols = 60,
  onChange,
  disabled = false,
  onBlur,
  onFocus,
  onPaste,
  ...rest
}: ITextArea) => {
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = React.useState(false);
  return (
    <Label className={styles.label}>
      {labelHidden ? <VisuallyHidden>{label}</VisuallyHidden> : label}
      <textarea
        onFocus={onFocus}
        onBlur={onBlur}
        value={value}
        rows={rows}
        cols={cols}
        disabled={disabled}
        onChange={onChange}
        className={classNames(styles.input, {
          [styles.error]: hasError,
        })}
        onPaste={onPaste}
        {...rest}
      />
    </Label>
  );
};

export default TextArea;
